import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { merge } from 'rxjs';

import {
  AttachmentsActions,
  AttachmentsDataScope,
  getAttachmentStoreScope,
} from '@core/attachments-data';
import { FullCandidateActions } from '@core/candidate-data';
import { InterviewEventsActions, interviewEventsCandidateScope } from '@core/interview-events-data';
import { TasksActions } from '@core/tasks-data';

import { CandidatesRealtimeHandler } from './candidates-realtime-handler.service';

@Injectable()
export class CandidateRevealWsService {
  private handler = inject(CandidatesRealtimeHandler);
  private store = inject(Store);

  private onCandidateRevealOrHide$ = merge(this.handler.revealed$, this.handler.concealed$)
    .pipe(takeUntilDestroyed())
    .subscribe(({ candidateId }) => {
      this.store.dispatch(FullCandidateActions.fetchOne({ payload: { id: candidateId } }));
      this.store.dispatch(TasksActions.fetchCandidateTasks({ payload: { data: { candidateId } } }));
      this.store.dispatch(
        InterviewEventsActions.fetchCollection({
          payload: {
            params: { candidateId },
            scope: interviewEventsCandidateScope(candidateId),
          },
        }),
      );
      this.store.dispatch(
        AttachmentsActions.fetchAttachmentsByCandidate({
          payload: {
            params: { candidateId },
            scope: getAttachmentStoreScope(AttachmentsDataScope.Candidate, candidateId),
          },
        }),
      );
    });
}
